export default class TyreHotel {
  public id: number
  public bookingServiceId: number
  public productDescription: string
}
